module.exports = __webpack_public_path__ + "static/img/upload.83342aab.png";